// docs: https://github.com/altostra/type-validations#readme
import { objectOf /*, maybe */ } from "@altostra/type-validations";
import { string, number } from "@altostra/type-validations/lib/primitives";

export const isAppsUserInfoUserDeletionRecordDatatableResult = objectOf({
  id: string,
  request_date: string,
  deletion_date: string,
  status: string,
  segment_id: string,
  num_users_to_delete: number,
  num_users_processed: number,
  initiated_by: string,
  initiated_by_email: string,
});
